import React from 'react';
import { Link } from 'react-router-dom';

// Translations
import translate from './Translate.js';

// Dependencies
import jwt_decode from 'jwt-decode';

// Components
import * as icons from './Icons/Icons';

class Unauthorized extends React.Component {
  componentWillMount() {
    const token = this.props.routing.location.search.split('token=')[1];
    if(token) {
      this.payload = jwt_decode(token);
    }
  }

  render() {
    const { translation } = this.props;

    return(
      <main className="page page--error wrap">
        <div className="panel--brief">
          <i className="page--error__icon"><icons.iconLock /></i>

          {typeof this.payload !== 'undefined' &&
            <div>
              <h1 className="panel__title">{translation[this.payload.errorCode].heading}</h1>
              <p>{translation[this.payload.errorCode].message}</p>
              <Link className="btn--outline" to={this.payload.returnUrl}>{translation[this.payload.errorCode].button}</Link>
            </div>
          }

          {typeof this.payload === 'undefined' &&
          <div>
            <h1 className="panel__title">{translation.default.heading}</h1>
            <p>{translation.default.message}</p>
            <Link className="btn--outline" to="/">{translation.default.button}</Link>
          </div>
          }
        </div>
      </main>
    )
  }
}

export default translate('Unauthorized')(Unauthorized);


// WEBPACK FOOTER //
// ./src/app/components/Unauthorized.js